<template>
  <div class="apply-form">
    <h1 class="form-title">{{ $cms('c_ff3b5a737193', 'f_0001', "立即申请，成为品牌合作主播") }}</h1>
    <div class="form-desc">
      <h2>{{ $cms('c_ff3b5a737193', 'f_0002', "主播合作问卷") }}</h2>
      <p>
        {{ $cms('c_ff3b5a737193', 'f_0003', "请详细填写以下信息，我们会根据您的资料评估合作潜力，并在3个工作日内联系商务经理启动1v1洽谈！") }}
      </p>
    </div>
    <div class="form-content">
      <el-form ref="form" :model="form" :rules="rules" :inline="false" label-position="top">
        <!-- 一、基础信息 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_ff3b5a737193', 'f_0004', "一、基础信息") }}</h3>
          
          <el-form-item class="form-item" prop="anchorName" :label="$cms('c_ff3b5a737193', 'f_0005', &quot;1. 姓名/团队名称：&quot;)">
            <el-input v-model="form.anchorName" :placeholder="$cms('c_ff3b5a737193', 'f_0006', &quot;请输入姓名/团队名称&quot;)" class="learn"></el-input>
          </el-form-item>

          <div class="row">
            <el-form-item class="form-item" prop="phone" :label="$cms('c_ff3b5a737193', 'f_0007', &quot;2. 联系方式：手机&quot;)">
              <el-input v-model="form.phone" :placeholder="$cms('c_ff3b5a737193', 'f_0008', &quot;请输入手机号&quot;)" class="learn"></el-input>
            </el-form-item>
            <el-form-item class="form-item" prop="wechat" :label="$cms('c_ff3b5a737193', 'f_0009', &quot;微信&quot;)">
              <el-input v-model="form.wechat" :placeholder="$cms('c_ff3b5a737193', 'f_0010', &quot;请输入微信号&quot;)" class="learn"></el-input>
            </el-form-item>
          </div>

          <el-form-item class="form-item" prop="platforms" :label="$cms('c_ff3b5a737193', 'f_0011', &quot;3. 主要平台账号（例：抖音/快手/小红书）：&quot;)">
            <div class="platform-inputs">
              <div v-for="(platform, index) in form.platforms" :key="index" class="platform-row">
                <div class="row platform-info">
                  <el-input v-model="platform.name" :placeholder="$cms('c_ff3b5a737193', 'f_0012', &quot;平台&quot;)" class="platform-input"></el-input>
                  <el-input v-model="platform.account" :placeholder="$cms('c_ff3b5a737193', 'f_0013', &quot;账号名&quot;)" class="platform-input"></el-input>
                  <el-input v-model="platform.fans" :placeholder="$cms('c_ff3b5a737193', 'f_0014', &quot;粉丝量&quot;)" class="platform-input"></el-input>
                  <el-button v-if="form.platforms.length > 1" @click="removePlatform(index)" type="danger" size="small" icon="el-icon-delete"></el-button>
                </div>
              </div>
              <el-button v-if="form.platforms.length < 3" @click="addPlatform" size="small" plain>{{ $cms('c_ff3b5a737193', 'f_0015', "添加平台") }}</el-button>
              <p class="tip-text">{{ $cms('c_ff3b5a737193', 'f_0016', "（可多平台填写，最多3个）") }}</p>
            </div>
          </el-form-item>
        </div>

        <!-- 二、带货能力 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_ff3b5a737193', 'f_0017', "二、带货能力") }}</h3>
          
          <el-form-item class="form-item" prop="categories" :label="$cms('c_ff3b5a737193', 'f_0018', &quot;1. 擅长类目（多选）：&quot;)">
            <el-checkbox-group v-model="form.categories">
              <el-checkbox 
                v-for="option in categoryOptions" 
                :key="option" 
                :label="option"
              >
                {{ option }}
              </el-checkbox>
            </el-checkbox-group>
            <el-form-item prop="otherCategory" :label="$cms('c_ff3b5a737193', 'f_0019', &quot;其他&quot;)">
              <el-input v-model="form.otherCategory" :placeholder="$cms('c_ff3b5a737193', 'f_0020', &quot;请输入其他类目&quot;)" class="learn"></el-input>
            </el-form-item>
          </el-form-item>

          <el-form-item class="form-item" prop="salesData" :label="$cms('c_ff3b5a737193', 'f_0021', &quot;2. 最近3个月带货数据（可大致区间）：&quot;)">
            <div class="sales-data">
              <div class="row">
                <div class="data-item">
                  <label>{{ $cms('c_ff3b5a737193', 'f_0022', "场均成交额：") }}</label>
                  <el-input v-model="form.salesData.avgSales" :placeholder="$cms('c_ff3b5a737193', 'f_0023', &quot;请输入场均成交额&quot;)" class="learn"></el-input>
                </div>
              </div>
              <div class="row">
                <div class="data-item">
                  <label>{{ $cms('c_ff3b5a737193', 'f_0024', "单场最高GMV：") }}</label>
                  <el-input v-model="form.salesData.maxGMV" :placeholder="$cms('c_ff3b5a737193', 'f_0025', &quot;请输入单场最高GMV&quot;)" class="learn"></el-input>
                </div>
              </div>
              <div class="row">
                <div class="data-item">
                  <label>{{ $cms('c_ff3b5a737193', 'f_0026', "核心转化品：") }}</label>
                  <el-input v-model="form.salesData.coreProducts" :placeholder="$cms('c_ff3b5a737193', 'f_0027', &quot;请输入核心转化品&quot;)" class="learn"></el-input>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item class="form-item" prop="brandFeatures" :label="$cms('c_ff3b5a737193', 'f_0028', &quot;3. 您认为我的品牌产品最吸引用户的3个特点：&quot;)">
            <div class="features-input">
              <div class="row">
                <el-input v-model="form.brandFeatures.feature1" :placeholder="$cms('c_ff3b5a737193', 'f_0029', &quot;特点1&quot;)" class="learn"></el-input>
                <span class="separator">/</span>
                <el-input v-model="form.brandFeatures.feature2" :placeholder="$cms('c_ff3b5a737193', 'f_0030', &quot;特点2&quot;)" class="learn"></el-input>
                <span class="separator">/</span>
                <el-input v-model="form.brandFeatures.feature3" :placeholder="$cms('c_ff3b5a737193', 'f_0031', &quot;特点3&quot;)" class="learn"></el-input>
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- 三、合作匹配度 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_ff3b5a737193', 'f_0032', "三、合作匹配度") }}</h3>
          
          <el-form-item class="form-item" prop="cooperationForm" :label="$cms('c_ff3b5a737193', 'f_0033', &quot;1. 期望的合作形式：&quot;)">
            <el-checkbox-group v-model="form.cooperationForm">
              <el-checkbox 
                v-for="option in cooperationFormOptions" 
                :key="option" 
                :label="option"
              >
                {{ option }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item class="form-item" prop="frequency" :label="$cms('c_ff3b5a737193', 'f_0034', &quot;2. 可配合的推广频率：&quot;)">
            <el-checkbox-group v-model="form.frequency">
              <el-checkbox 
                v-for="option in frequencyOptions" 
                :key="option" 
                :label="option"
              >
                {{ option }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>

        <!-- 四、补充说明 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_ff3b5a737193', 'f_0035', "四、补充说明") }}</h3>
          <el-form-item class="form-item" prop="expectations" :label="$cms('c_ff3b5a737193', 'f_0036', &quot;请简述您对本次合作的期待或建议（50字内）：&quot;)">
            <el-input 
              v-model="form.expectations" 
              type="textarea" 
              :rows="3"
              maxlength="50"
              show-word-limit
:placeholder="$cms('c_ff3b5a737193', 'f_0037', &quot;请输入您的期待或建议&quot;)"
              class="learn"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div 
      class="submit-btn" 
      :class="{ 'submitting': isSubmitting }"
      @click="submitForm"
    >
      <span v-if="!isSubmitting">{{ $cms('c_ff3b5a737193', 'f_0038', "提交申请") }}</span>
      <span v-else>{{ $cms('c_ff3b5a737193', 'f_0039', "提交中...") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Type3Form',
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        anchorName: '',
        phone: '',
        wechat: '',
        platforms: [
          { name: '', account: '', fans: '' }
        ],
        categories: [],
        otherCategory: '',
        salesData: {
          avgSales: '',
          maxGMV: '',
          coreProducts: ''
        },
        brandFeatures: {
          feature1: '',
          feature2: '',
          feature3: ''
        },
        cooperationForm: [],
        frequency: [],
        expectations: ''
      },
      // 选项数据
      categoryOptions: [
        '美妆护肤',
        '食品生鲜',
        '母婴儿童',
        '家居日用',
        '数码电器',
        '服饰鞋包',
        '健康保健'
      ],
      cooperationFormOptions: [
        '纯佣金',
        '坑位费+佣金',
        '独家代理',
        '品宣植入'
      ],
      frequencyOptions: [
        '单次测试',
        '每月1-2场',
        '每周固定场次'
      ],
      rules: {
        anchorName: [
          { required: true, message: '请输入姓名/团队名称', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        wechat: [
          { required: true, message: '请输入微信号', trigger: 'blur' },
        ],
        categories: [
          { required: true, message: '请选择擅长类目', trigger: 'change' },
        ],
        cooperationForm: [
          { required: true, message: '请选择期望的合作形式', trigger: 'change' },
        ],
        frequency: [
          { required: true, message: '请选择可配合的推广频率', trigger: 'change' },
        ],
      }
    }
  },
  methods: {
    // 添加平台
    addPlatform() {
      if (this.form.platforms.length < 3) {
        this.form.platforms.push({ name: '', account: '', fans: '' });
      }
    },

    // 移除平台
    removePlatform(index) {
      if (this.form.platforms.length > 1) {
        this.form.platforms.splice(index, 1);
      }
    },

    // 提交表单
    submitForm() {
      if (this.isSubmitting) {
        return; // 如果正在提交，直接返回
      }
      
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('表单数据:', this.form);
          this.$emit('submit', this.form);
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },

    // 获取表单数据
    getFormData() {
      return this.form;
    },

    // 验证表单
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(valid);
        });
      });
    }
  },
}
</script>

<style lang="less" scoped>
@import "./apply-join.less";

.form-section {
  margin-bottom: 40px;
  
  .section-title {
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    line-height: 28px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #DCDFE6;
  }
}

.platform-inputs {
  .platform-row {
    margin-bottom: 15px;
    
    .platform-info {
      align-items: center;
      gap: 15px;
      
      .platform-input {
        flex: 1;
      }
    }
  }
  
  .tip-text {
    font-size: 14px;
    color: #999;
    margin: 10px 0 0 0;
  }
}

.sales-data {
  .data-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    
    label {
      min-width: 120px;
      font-weight: 500;
      color: #333;
    }
    
    .el-input {
      flex: 1;
    }
  }
}

.features-input {
  .separator {
    margin: 0 15px;
    font-size: 18px;
    color: #666;
  }
}

/deep/ .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 20px;
  
  .el-checkbox {
    margin-right: 0;
  }
}

/deep/ .el-form-item__label {
  font-weight: 500;
  color: #333;
}

/deep/ .el-textarea__inner {
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  
  &:focus {
    border-color: #FF6600;
  }
}
</style>
